import { Grid } from '@mui/material';
import {
  ReceiptLong as PotsIcon,
  TrendingUp as GrossIcon,
  AccountBalanceWallet as NetIcon,
  RemoveCircleOutline as DeductionsIcon,
  LocationOn as SitesIcon,
  Groups as WorkersIcon,
} from '@mui/icons-material';
import { MetricCard } from '../atoms/MetricCard';
import { useGetDashboardMetrics } from '../../hooks/useGetDashboardMetrics';
import { formatCurrency } from '../../../../shared/utils/currency';

const metrics = [
  {
    key: 'activePots',
    label: 'Active Pots',
    icon: <PotsIcon />,
    color: '#5C9CE6',
    format: (v: number) => v.toLocaleString('en-GB'),
  },
  {
    key: 'grossValue',
    label: 'Gross Value',
    icon: <GrossIcon />,
    color: '#66BB6A',
    format: formatCurrency,
  },
  {
    key: 'netValue',
    label: 'Net Value',
    icon: <NetIcon />,
    color: '#AB47BC',
    format: formatCurrency,
  },
  {
    key: 'deductions',
    label: 'Deductions',
    icon: <DeductionsIcon />,
    color: '#EF5350',
    format: formatCurrency,
  },
  {
    key: 'activeSites',
    label: 'Active Sites',
    icon: <SitesIcon />,
    color: '#FF7043',
    format: (v: number) => v.toLocaleString('en-GB'),
  },
  {
    key: 'workers',
    label: 'Workers',
    icon: <WorkersIcon />,
    color: '#42A5F5',
    format: (v: number) => v.toLocaleString('en-GB'),
  },
] as const;

export function MetricsGrid() {
  const { data, isLoading } = useGetDashboardMetrics();

  return (
    <Grid container spacing={2}>
      {metrics.map(metric => (
        <Grid key={metric.key} size={{ xs: 6, sm: 4, lg: 2 }}>
          <MetricCard
            label={metric.label}
            value={
              data
                ? metric.format(data[metric.key as keyof typeof data] as number)
                : ''
            }
            icon={metric.icon}
            iconColor={metric.color}
            isLoading={isLoading}
            testId={`metric-${metric.key}`}
          />
        </Grid>
      ))}
    </Grid>
  );
}
